import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import "./modal.css";

export const Modal = ({ children, showModal, setShowModal }) => {
  if (showModal === false) return null;
  return (
    <div className="modal-wrapper" onClick={() => setShowModal((prev) => !prev)}>
      <div className="modal-content padding-sm" onClick={(e) => e.stopPropagation()}>
        {children}
        <AiOutlineClose
          className="close-btn"
          onClick={() => setShowModal((prev) => !prev)}
        />
      </div>
    </div>
  );
};
